export const breakpointsTheme = {
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1120, // override
      xl: 1920,
    },
  },
};
